import { RouteMeta, RouteRecordRaw } from 'vue-router'

export interface IPath {
    name?: string;
    url: string;
    isDetail?: boolean;
}

interface IRouteObject {
    path: IPath;
    component: any;
}

export const createRouteObject = function (route: IRouteObject, meta?: RouteMeta) : RouteRecordRaw {
    const path = route.path;
    return {
        name: path.name,
        path: path.url + (path.isDetail ? "/:id?" : ""),
        component: route.component,
        meta: meta
    }
}

const createPath = function (name: string, path: string, isDetail?: boolean): IPath {
    let url: string;
    if (!!path) {
        url = path.startsWith("/") ? path : `/${path}`;
    } else {
        url = `/${name}`;
    }
    return {
        name: name,
        url: `/m${url}`,
        isDetail: isDetail
    }
}

export default {
    startup: createPath("startup", "/"),
    login: createPath('login', "/login"),
    dashboard: createPath('dashboard', '/dashboard'),
    notification: createPath("notification", "/notification"),
    bill: createPath('bill', '/bill'),
    invoice: createPath('invoice', '/invoice'),
    invoiceDetail: createPath('invoiceDetail', '/invoice/:id'),
    viewInvoice: createPath('viewInvoice', '/invoice/view', true),
    createInvoice: createPath('createInvoice', '/invoice/create'),
    EditInvoice: createPath('editInvoice', '/invoice/edit', true),
    editInvoiceInformation: createPath('editInvoiceInformation', '/invoice/info/edit'),
    invoicePackage: createPath('invoicePackage', '/invoice/package'),
    invoicePackagePayment: createPath('invoicePackagePayment', '/invoice/package/payment'),
    invoicePackageWallet: createPath('invoicePackageWallet', '/invoice/package/wallet'),
    InvoicePackageOrderCompleted: createPath('InvoicePackagePaymentCompleted', '/invoice/package/order-completed', true),
    InvoicePackagePaymentCompleted: createPath('InvoicePackagePaymentCompleted', '/invoice/package/payment-completed'),
    invoiceChoosePaymentType: createPath('invoiceChoosePaymentType', '/invoice/payment/choose'),
    invoiceChooseShop: createPath('invoiceChooseShop', '/invoice/shop/choose'),
    invoiceFormShop: createPath('invoiceFormShop', '/invoice/shop/form'),
    invoiceShopDetail: createPath('invoiceShopDetail', '/invoice/shop/detail', true),
    invoiceChooseCustomer: createPath('invoiceChooseCustomer', '/invoice/customer/choose'),
    invoiceFormCustomer: createPath('invoiceFormCustomer', '/invoice/customer/form'),
    invoiceCustomerDetail: createPath('invoiceCustomerDetail', '/invoice/customer/detail', true),
    invoiceProduct: createPath('invoiceProduct', '/invoice/product'),
    invoiceAddProduct: createPath('invoiceAddProduct', '/invoice/product/add'),
    invoiceChooseCurrency: createPath('invoiceChooseCurrency', '/invoice/currency/choose'),
    account: createPath('account', "/account"),
    editAccount: createPath('editAccount', '/account/edit'),
    shopList: createPath('shopList', '/shop'),
    shopForm: createPath('shopForm', '/shop/form', true),
    shopDetail: createPath('shopDetail', '/shop/detail', true),
    customerCredit: createPath('customerCredit', '/customer/credit'),
    customerCreditDetail: createPath('customerCreditDetail', '/customer/credit/detail', true),
    customerList: createPath('customerList', '/customer'),
    customerForm: createPath('customerForm', '/customer/form', true),
    customerDetail: createPath('customerDetail', '/customer/detail', true),
    productList: createPath('productList', '/product'),
    productForm: createPath('productForm', '/product/form', true),
    profile: createPath("profile", "/account/profile"),
    settings: createPath("settings", "/account/settings"),
    infoLanding: createPath("infoLanding", "/account/profile/info"),
    changePassword: createPath("changePassword", "/account/profile/change-password"),
    changeLanguage: createPath("changeLanguage", "/account/profile/change-language"),
    updateInfo: createPath("updateInfo", "/account/profile/update-info"),
    accountOrders: createPath("accountOrders", "/account/orders"),
    cashFlow: createPath("cashFlow", "/cash-flow")
}

